import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AdmakerService } from './admaker.service';
import { ActivatedRoute } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { adPart, AucClient } from './models';
import { ProcessRunService } from '../process-runner-select/shared/process-run.service';
import { DOCUMENT } from '@angular/common';
import { MatStep, MatStepper } from '@angular/material/stepper';
@Component({
  selector: 'app-admaker',
  templateUrl: './admaker.component.html',
  styleUrls: ['./admaker.component.css']
})
export class AdmakerComponent implements OnInit {

  valueChooser(name: string) {
    let n = name.toLowerCase();
    let value = 'None';
    switch (n) {
      case 'make':
        value = "Ford"
        break;
      case 'model':
        value = "Ecosport"
        break;
      case 'colour':
        value = "Red"
        break;
      case 'fueltype':
        value = "Petrol"
        break;
      case 'doors':
        value = "4 Doors"
        break;
      case 'year':
        value = "2019"
        break;
      case 'bodytype':
        value = "SUV"
        break;
      case 'enginesize':
        value = "Ecosport"
        break;
      case 'milege':
        value = "6mi/L"
        break;
      case 'variant':
        value = "Titanium"
        break;
      case 'transmission':
        value = "manual"
        break;
      case 'displayname':
        value = "displayName"
        break;
      case 'displaylocation':
        value = "displayLocation"
        break;
      case 'seed':
        value = "Seed"
        break;
      case 'price':
        value = "£"
        break;
      default:
        value = 'None';
        break;
    }
    return value;

  }

  Allelements = [];

  getAdfields() {
    this.adms.getAdCFields().subscribe((r: any) => {
      let fields: any[] = r['adFields'];
      fields.map((e: any) => {
        e.type = 'button';
        e.etype = 'elements';
        e.inList = false;
        e.inListValue = this.valueChooser(e.name),
          e.isspace = e.name.toLowerCase() == 'price' ? true : true
      })
      this.Allelements = fields;
    })
  }
  themes: string[] = [];

  isEditable = false;
  themetype;
  themearr = [];
  selected;
  selectedTheme = '';
  currentOrder: Number = 1;

  clientList: AucClient[] = [];
  selectedClient: any = null;

  @ViewChild('stepper') stepper: MatStepper;
  constructor(private adms: AdmakerService, private route: ActivatedRoute, private prs: ProcessRunService, @Inject(DOCUMENT) private document: Document, private elRef: ElementRef
  ) {
    this.getAdfields();
    this.getAdGroups();
    //this.seedToDropes();
    this.route.queryParams.subscribe(
      (res: any) => {
        this.themetype = res.themetype;
        if (this.themetype == 'custom') {
          this.getAucClients();
          this.getSettings();
        } else {

          this.selectedClient = null;
        }
      }
    )




    this.getSettings();

    //window.addEventListener("scroll", function () {
    //  console.log(document.getElementsByClassName("step_admaker")[0].classList)
    //  console.log("csscsc")
    //  if (window.pageYOffset >= 148) {
    //    document.getElementsByClassName("step_admaker")[0].classList.add("fix_active");
    //  }
    //  else {
    //    document.getElementsByClassName("step_admaker")[0].classList.remove("fix_active");
    //  }
    //})

  }

  scrolled() {

  }

  checkIsThere(s) {
  
    let selected: string = JSON.parse(localStorage.getItem("selected")) || "";
    if (selected.includes(s)) {
      //console.log("yes")
      return true;
    }
    return false;
  }

  getAucClients() {
    this.prs.getClientes('auc').subscribe((res: any) => {
      //console.log(res);
      this.clientList = res
    }, (err) => {
      //console.log(err)
    })
  }

  loadAdmaker() {
    if (this.themetype == 'custom') {
      if (this.selectedClient && this.selectedTheme) {
        return true;
      }
      return false;
    } else {
      if (this.selectedTheme) {
        return true;
      }
      return false;
    }
  }

  ordersdefined = [1, 2, 3, 4, 5];
  newsettings = [];

  //settings = [
  //  { name: 'heading1', limit: 30 },
  //  { name: 'heading2', limit: 30 },
  //  { name: 'heading3', limit: 30 },

  //  { name: 'path1', limit: 30 },
  //  { name: 'path2', limit: 30 },
  //  { name: 'deeplink', limit: 30 },
  //]

  ngOnInit(): void {
    this.getAllAdConfigs();
    this.adms.delAdconfig.subscribe((r) => {
      this.delete(r);
    })
    this.adms.savelocal.subscribe(r => {
      this.saveNewcopyLocally(r);
    })
  }
  stepper_event(e) {

    //console.log(e);

    localStorage.setItem('selected', JSON.stringify(e.selectedStep.label));
    let adPart_id = this.Adparts.find(es => {
      return e.selectedStep.label == es.part;
    });
    adPart_id = adPart_id.id;
    localStorage.setItem('adPart_id', JSON.stringify(adPart_id));

    this.adms.changeStepper.emit();
  }
  //  switchTheme(e){
  //this.adms.switchTheme.emit(e);
  //    //console.log(e)
  //  }

  getTheme() {
    let selected = JSON.parse(localStorage.getItem("selected")) || "";
    let selectedCopy = JSON.parse(localStorage.getItem("allTheme"))[selected];
    if (selectedCopy) {
      if (selectedCopy[this.currentOrder.toString()]) {
        this.selectedTheme = selectedCopy['theme'];

      }
    }
    //console.log(this.selectedTheme);

  }

  change_tab(tab: MatTabChangeEvent) {

    let ind = tab.index;
    let name = this.newsettings[ind].settings[0].name;
    let adPart_id = this.newsettings[ind].settings[0].id;

    localStorage.setItem('selected', JSON.stringify(name));
    localStorage.setItem('adPart_id', JSON.stringify(adPart_id));
    this.adms.changeStepper.emit();
    //this.selectedIndex = 0;
    //this.stepper.selectedIndex = 0;
    //var div: HTMLElement[] = this.elRef.nativeElement.querySelectorAll('.step_admaker');
    //div.forEach((e) => {
    //  e.setAttribute("selectedIndex", "0");
    //  console.log(e);
    //}  )
  }
  selectedIndex = 0;

  getAdGroups() {
    this.adms.getAdGroups().subscribe((r: any) => {

      this.themes = r['adGroups'];
    })
  }
  Adparts: any[];

  getSettings() {
    this.adms.getAdParts().subscribe((s: any) => {
      this.Adparts = s.adParts;
      let adp = [];
      this.Adparts.forEach(ap => {
        adp.push({ id: ap.id, name: ap.part, limit: ap.length, group: ap.group, code: ap.shortCode })
      })
      this.settingsMaker(adp);
      localStorage.setItem('selected', JSON.stringify(this.newsettings[0].settings[0].name));
      this.selected = JSON.parse(localStorage.getItem('selected'));
    }, (err) => {

    })
  }

  seedToDropes() {
    //let str = 'Why not test drive this <year> <colour> <make> <model> with <mileage> miles. Now Only £<price>';
    let str = 'Look online or call <displayName> <displayLocation> for more information on the <make> <model> today';
    //let str = '<engineSize> <fuelType> With <mileage> Miles';
    //let str = '<make> <model>';
    let arrstrr = str.split(' ');


    let ne = [];
    arrstrr.forEach((a) => {
      if (a.includes('<') && a.includes('>') && (a.charAt(0) !== '<' || a.charAt(a.length - 1) !== '>')) {
        let rev; let result;
        if (a.charAt(0) !== '<') {
          rev = a.split("").reverse().join("");
          result = a.substr(-(rev.indexOf('<') + 1), a.length);
          ne.push(a.substr(0, a.indexOf('<')))
          //console.log(result)

        } else if (a.charAt(a.length - 1) !== '>') {
          rev = a.split("").reverse().join("");

          result = a.substr(0, a.indexOf('>') + 1);
          //console.log(result)
          ne.push(a.substr(-(rev.indexOf('>')), a.length));

        }
        ne.push(result);



      } else {
        ne.push(a);
      }
    })
    //console.log(ne)

    let elements = [
      {
        id: 1,
        code: "<make>",
        name: "Make",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Ford"
      },
      {
        id: 2,
        code: "<model>",
        name: "Model",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Ecosport"
      },
      {
        id: 3,
        code: "<colour>",
        name: "Colour",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Red"
      },
      {
        id: 4,
        code: "<year>",
        name: "Year",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "2019"
      },
      {
        id: 5,
        code: "<price>",
        name: "Price",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "None"
      },
      {
        id: 6,
        code: "<mileage>",
        name: "Mileage",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "None"
      },
      {
        id: 7,
        code: "<fuelType>",
        name: "FuelType",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Petrol"
      },
      {
        id: 8,
        code: "<bodyType>",
        name: "BodyType",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "SUV"
      },
      {
        id: 9,
        code: "<engineSize>",
        name: "EngineSize",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Ecosport"
      },
      {
        id: 10,
        code: "<doors>",
        name: "Door",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "None"
      },
      {
        id: 11,
        code: "<variant>",
        name: "Variant",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Titanium"
      },
      {
        id: 12,
        code: "<transmission>",
        name: "Transmission",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "manual"
      },
      {
        id: 13,
        code: "<displayName>",
        name: "DisplayName",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "displayName"
      },
      {
        id: 14,
        code: "<displayLocation>",
        name: "DisplayLocation",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "displayLocation"
      },
      {
        id: 15,
        code: "<seed>",
        name: "Seed",
        type: "button",
        etype: "elements",
        inList: false,
        inListValue: "Seed"
      }
    ];
    let droppes = [];
    ne.forEach((n) => {
      if (n.includes('<') && n.includes('>')) {
        let inOfel = elements.find((s) => { return s.code == n });
        if (inOfel) {
          droppes.push(inOfel);
        } else {
          droppes.push(n);
        }
      } else {
        droppes.push(n);
      }
    })
    //console.log(droppes)
    let finalDropes = [];
    let st = "";
    droppes.forEach((sx, insx) => {
      let nxtelemObj = "";
      if (typeof (droppes[insx + 1]) == 'string') {
        nxtelemObj = " ";
      } else {
        nxtelemObj = "";
      }
      if (typeof (sx) == 'string') {
        //console.log(sx);
        st = st + sx + nxtelemObj;
        if ((insx + 1) == droppes.length) {
          let stob = { name: st, type: "text", inList: true, inListValue: st, etype: 'phrase' }
          finalDropes.push(stob);
        }
      } else {
        if (st) {
          let stob = { name: st, type: "text", inList: true, inListValue: st, etype: 'phrase' }
          finalDropes.push(stob);
          st = "";
        }
        finalDropes.push(sx);
      }

    })
    //console.log(finalDropes);
  }
  decideSHortForm(group: string, part: string) {
    let str: string;
    var p: string = part;
    if (group == "Headlines") {
      p = p.replace("Headline_", "");
      str = "H" + part[9] + (part[10] || "");
      if (part.length == 19) {
        str = str + "P";
      }
      return str.replace("_", "");
    }
    else if (group == "Description") {
      p = p.replace("Description_", "");
      str = "D" + part[12] + (part[13] || "");
      if (part.length == 22) {
        str = str + "P";
      }
      return str.replace("_", "");
    }
    else if (group == "Path") {
      p = p.replace("Path_", "");
      str = "P" + part[5] + (part[6] || "");
      //if (part.length == 22) {
      //  str = str + "P";
      //}
      return str;
    }
    else if (group == "Link") {
      str = "DL"
      return str;
    }


    return "H1"
  }
  settingsMaker(adparts: adPart[]) {
    let adgroups = [];
    //adparts.map((adp: adPart) => {
    //  adp.code = this.decideSHortForm(adp.group, adp.name)
    //})
    //console.log(adparts)
    adparts.forEach((ap: any) => {
      adgroups.push(ap.group);
    })
    adgroups = [...new Set(adgroups)];
    let settings = [];
    adgroups.forEach((adgr) => {
      settings.push({ type: adgr, settings: adparts.filter(es => { return es.group == adgr }) })
    })
    //console.log(settings)
    this.newsettings = settings;
    let name = this.newsettings[0].settings[0].name;
    let adPart_id = this.newsettings[0].settings[0].id;

    localStorage.setItem('selected', JSON.stringify(name));
    localStorage.setItem('adPart_id', JSON.stringify(adPart_id));

  }

  confsReady = false;

  AllAdConfigs: any[];
  getAllAdConfigs() {
    this.adms.getAllAdConfigs().subscribe((r: any) => {
      this.AllAdConfigs = r.adConfigs;
      this.AllAdConfigs.map((e) => {
        e.tempid = e.id;
      })
      this.confsReady = true;
    }, (err) => {
      this.confsReady = true;

    })
  }

  getAd(adPartId, theme) {
    let ad = this.AllAdConfigs.filter(e => {
      if (this.themetype == 'default') {
        return e.adPartId == adPartId && e.adThemeId == theme && e.clientId == null;
      } else {
        return e.adPartId == adPartId && e.adThemeId == theme && e.clientId == this.selectedClient;
      }
    })
    return ad;
  }

  getAdLenghth(adPartId, theme, fromLocalHost = false) {
    if (fromLocalHost) {
      adPartId = JSON.parse(localStorage.getItem('adPart_id'));
    }
    let ad = this.AllAdConfigs.filter(e => {
      if (this.themetype == 'default') {
        return e.adPartId == adPartId && e.adThemeId == theme && e.clientId == null;
      } else {
        return e.adPartId == adPartId && e.adThemeId == theme && e.clientId == this.selectedClient;
      }
    })
    return ad.length;
  }
  getAdLenghthFromSettings(set: any[]) {
    let co = 0;
    set.forEach((e) => {
      co += this.getAdLenghth(e.id, this.selectedTheme);
    })
    return co;
  }

  getAdIndex(adPartId, theme, clientId, adOrder) {
    let ina = null;
    this.AllAdConfigs.forEach((e, iii) => {

      if (e.adPartId == adPartId && e.adThemeId == theme && e.clientId == clientId && e.adOrder == adOrder) {
        ina = iii;
        //console.log("sccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc")
      }

    })
    return ina;
  }

  delete(data) {
    //let intodelete = this.getAdIndex(data.AdPartId, data.AdThemeId, data.ClientID, data.AdOrder);
    let intodelete = this.AllAdConfigs.findIndex((ads) => { return ads.tempid == data.tempid });
    if (intodelete => 0) {
      //console.log(data);
      //console.log(intodelete)
      this.AllAdConfigs.splice(intodelete, 1);
    }
  }

  addOrder(order, partId, theme) {
    let obj = {
      adOrder: order,
      adPartId: partId,
      adThemeId: theme,
      clientId: this.selectedClient,
      seedText: "",
      isNew: true,
      tempid: this.generateTempId()
    }
    this.AllAdConfigs.push(obj);
  }

  generateTempId() {
    let id: number = Math.random() + new Date().getTime();
    id = Math.round(id);
    let fil = this.AllAdConfigs.filter((e) => { return e.tempid == id })
    if (fil.length == 0) {
      return id;
    } else {
      this.generateTempId();
    }
  }


  saveNewcopyLocally(data: any) {
    /* let index = this.AllAdConfigs.findIndex((ads) => { return ads.adPartId == data.AdPartId && ads.adThemeId == data.AdThemeId && ads.adOrder == data.AdOrder && ads.clientId == data.ClientID });*/

    let index = this.AllAdConfigs.findIndex((ads) => { return ads.tempid == data.tempid });
    if (index >= 0) {
      //console.log(index);
      //console.log(this.AllAdConfigs[index]);
      this.AllAdConfigs[index]['seedText'] = data['SeedText'];
      this.AllAdConfigs[index]['adOrder'] = data['AdOrder'];
      this.AllAdConfigs[index]['id'] = data['id'];
      this.AllAdConfigs[index]['tempid'] = data['id'];
    }
  }



  decideColumns() {

    if (this.themetype == 'default') {


      return 3;
    }
    else if (this.themetype == 'custom') {

      return 4;
    }



    return 4;
  }

  activeReloadData() {
    if (this.themetype == 'default') {
      return this.loadAdmaker();
    } else if (this.themetype == 'custom') {
      this.selectedClient;
    }
    return this.selectedClient;

  }
}
